// docs: https://github.com/altostra/type-validations#readme
import { objectOf, arrayOf, maybe, anyOf } from "@altostra/type-validations";
import { number, string, boolean, nullValidation } from "@altostra/type-validations/lib/primitives";

const nullableString = anyOf(string, nullValidation);
const nullableNumber = anyOf(number, nullValidation);
const nullableBoolean = anyOf(boolean, nullValidation);

const isVerifiedDomainDnsRecord = objectOf({
  type: string,
  name: string,
  value: string,
  status: string,
  found_value: maybe(string),
  error_reason: maybe(string),
});

const isNestedVerifiedDomain = objectOf({
  id: string,
  rootDomain: string,
  domain: string,
  status: string,
  tls_status: maybe(nullableString),
  type: string,
  created_at: maybe(nullableNumber),
  expires_at: maybe(nullableNumber),
  activated_at: maybe(nullableNumber),
  dns_records: maybe(arrayOf(isVerifiedDomainDnsRecord)),
  ns_verified: maybe(nullableBoolean),
  txt_verified: maybe(nullableBoolean),
  channel: maybe(string),
  workspace_count: maybe(number),
});

const isVerifiedDomain = objectOf({
  id: string,
  rootDomain: string,
  domain: string,
  status: string,
  tls_status: maybe(nullableString),
  type: string,
  created_at: maybe(nullableNumber),
  expires_at: maybe(nullableNumber),
  activated_at: maybe(nullableNumber),
  dns_records: maybe(arrayOf(isVerifiedDomainDnsRecord)),
  custom_domains: maybe(arrayOf(isNestedVerifiedDomain)),
  ns_verified: maybe(nullableBoolean),
  txt_verified: maybe(nullableBoolean),
  channel: maybe(string),
  workspace_count: maybe(number),
});

const isVerifiedDomainLimits = objectOf({
  current: number,
  max: number,
});

export const isGetCompaniesCompanyIdVerifiedDomainsResult = objectOf({
  hits: number,
  results: arrayOf(isVerifiedDomain),
  has_ses_account: boolean,
  has_non_ses_esp_account: boolean,
  limits: isVerifiedDomainLimits,
});

export const isPostCompaniesCompanyIdVerifiedDomainsResult = isVerifiedDomain;
